<template>
  <div>
    <a-button icon="filter" type="primary" @click="visible = true">
      Filter
    </a-button>
    <a-drawer
      title="Filter"
      placement="right"
      @close="onCloseDrawer"
      :closable="false"
      :visible="visible"
      width="450"
      :bodyStyle="{ height: 'calc(100% - 100px)', overflowY: 'auto' }"
    >
      <a-form-model
        layout="vertical"
        v-bind="{
          labelCol: { span: 24 },
          wrapperCol: { span: 24 },
        }"
        style="margin-top: 20px;"
      >
        <a-form-model-item label="Gender">
          <a-select
            v-model="filter.gender"
            allowClear
            placeholder="Gender"
            style="width: 100%;"
            @change="onFilter"
          >
            <a-select-option value="NONE">
              Other
            </a-select-option>
            <a-select-option value="MALE">
              Male
            </a-select-option>
            <a-select-option value="FEMALE">
              Female
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="Started date">
          <ChooseDate
            :nameField="'startedDate'"
            :form="filter"
            :setForm="setFilterItem"
            :onChoose="onFilter"
          />
        </a-form-model-item>

        <a-form-model-item label="Department">
          <SelectDepartment
            @change="onFilter"
            v-model="filter.departmentIds"
            :selectProps="{
              style: { width: '100%' },
              placeholder: 'Select department',
            }"
          />
        </a-form-model-item>
        <a-form-model-item label="Position">
          <SelectPosition
            v-model="filter.positionId"
            @change="onFilter"
            :selectProps="{
              style: { width: '100%' },
              placeholder: 'Select postion',
            }"
          />
        </a-form-model-item>
      </a-form-model>
      <div
        :style="{
          position: 'absolute',
          right: 0,
          bottom: 0,
          width: '100%',
          borderTop: '1px solid #e9e9e9',
          padding: '10px 16px',
          background: '#fff',
          textAlign: 'right',
          zIndex: 1,
        }"
      >
        <a-button style="margin-right: 10px;" @click="onCloseDrawer">
          Close
        </a-button>
        <a-button
          type="primary"
          :disabled="isDisabledResetFilter"
          @click="resetFilter"
        >
          Reset
        </a-button>
      </div>
    </a-drawer>
  </div>
</template>

<script>
import SelectPosition from "@/components/common/position/select";
import SelectDepartment from "@/components/common/department/select";
import ChooseDate from "./choose-date-filter.vue";

export default {
  components: { SelectPosition, SelectDepartment, ChooseDate },
  props: {
    isDisabledResetFilter: {
      type: Boolean,
      default: false,
    },
    filter: {
      type: Object,
      default: () => ({}),
    },
    onFilter: {
      type: Function,
      default: () => {},
    },
    resetFilter: {
      type: Function,
      default: () => {},
    },
    setFilterItem: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      visible: false,
    };
  },
  methods: {
    onCloseDrawer() {
      this.visible = false;
    },
  },
};
</script>

<style></style>
